<template>
	<v-card outlined>
		<v-card-text>
			<v-row no-gutters>
        <v-col>
          <v-row no-gutters class="text-caption">
            <v-col cols="12" class="text-body-2 font-weight-black primary--text">
              <translate>Body</translate>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Color</translate>
                <span class="font-weight-medium ml-1 grey--text">{{bodyColorName}}</span>
                <v-icon class="ml-1" :color="tongue.body.parts.body.fill" small>mdi-checkbox-blank-circle</v-icon>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Shape</translate>
                <span class="font-weight-medium ml-1 grey--text">{{bodyShapeName}}</span>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Size</translate>
                <span class="font-weight-medium ml-1 grey--text">{{bodySizeName}}</span>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Tension</translate>
                <span class="font-weight-medium ml-1 grey--text">{{bodyTensionName}}</span>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Humidity</translate>
                <span class="font-weight-medium ml-1 grey--text">{{bodyHumidityName}}</span>
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="tongue.cover.exist">
          <v-row no-gutters class="text-caption">
            <v-col cols="12" class="text-body-2 font-weight-black primary--text">
              <translate>Cover</translate>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Area</translate>
                <span class="font-weight-medium ml-1 grey--text">{{coverAreaName}}</span>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Quality</translate>
                <span class="font-weight-medium ml-1 grey--text">{{coverQuality}}</span>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Thickness</translate>
                <span class="font-weight-medium ml-1 grey--text">{{coverThickness}}</span>
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="tongue.marks.exist">
          <v-row no-gutters class="text-caption">
            <v-col cols="12" class="text-body-2 font-weight-black primary--text">
              <translate>Marks</translate>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Types</translate>
                <span class="font-weight-medium ml-1 grey--text">{{markTypes}}</span>
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row no-gutters class="text-caption">
            <v-col cols="12" class="text-body-2 font-weight-black primary--text">
              <translate>Movement</translate>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Deviation</translate>
                <span class="font-weight-medium ml-1 grey--text">{{movementType}}</span>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Trembling</translate>
                <span class="font-weight-medium ml-1 grey--text">
                  <span v-if="tongue.movement.trembling" v-translate>Yes</span>
                  <span v-translate v-else>No</span>
                </span>
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col>
          <v-row no-gutters class="text-caption">
            <v-col cols="12" class="text-body-2 font-weight-black primary--text">
              <translate>Veins</translate>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Type</translate>
                <span class="font-weight-medium ml-1 grey--text">{{veinsType}}</span>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Thickness</translate>
                <span class="font-weight-medium ml-1 grey--text">{{veinsThickness}}</span>
              </p>
            </v-col>
            <v-col cols="12" class="ml-2">
              <p class="font-weight-bold primary--text ma-0">
                <translate>Tortuosity</translate>
                <span class="font-weight-medium ml-1 grey--text">{{veinsTortuosity}}</span>
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
		</v-card-text>
	</v-card>
</template>

<script>
export default {
	name: "TongueDetails",
	props: ["tongue"],
	computed: {
		bodyColorName() {
			return this.getColorName(
				this.stringToRGBObject(this.tongue.body.parts.body.fill)
			);
		},
		bodyShapeName() {
			if (this.tongue.body.shape == "round") return this.$gettext("Round");
			if (this.tongue.body.shape == "triangle")
				return this.$gettext("Triangular");
			return this.$gettext("Square");
		},
		bodySizeName() {
			if (this.tongue.body.size == "small") return this.$gettext("Small");
			if (this.tongue.body.size == "normal") return this.$gettext("Normal");
			return this.$gettext("Large");
		},
		bodyHumidityName() {
			if (this.tongue.body.humidity == 0) return this.$gettext("Extremely Dry");
			if (this.tongue.body.humidity == 1) return this.$gettext("Dry");
			if (this.tongue.body.humidity == 2) return this.$gettext("Normal");
			if (this.tongue.body.humidity == 3) return this.$gettext("Wet");
			return this.$gettext("Extremely Wet");
		},
		bodyTensionName() {
			if (this.tongue.body.tension == 0)
				return this.$gettext("Extremely Flaccid");
			if (this.tongue.body.tension == 1) return this.$gettext("Flaccid");
			if (this.tongue.body.tension == 2) return this.$gettext("Normal");
			if (this.tongue.body.tension == 3) return this.$gettext("Rigid");
			return this.$gettext("Extremely Rigid");
		},
		coverAreaName() {
			if (this.tongue.cover.area == "total") return this.$gettext("Total");
			return this.$gettext("Partial");
    },
    coverQuality() {
			if(this.tongue.cover.quality == "normal") return this.$gettext('Normal');
			if(this.tongue.cover.quality == "sticky") return this.$gettext('Sticky');
			return this.$gettext('Geographic');
		},
		coverThickness() {
			if(this.tongue.cover.thickness == 0) return this.$gettext('Slim');
			if(this.tongue.cover.thickness == 1) return this.$gettext('Medium');
			return this.$gettext('Thick');
		},
		markTypes() {
			let text = "";
			if(this.tongue.marks.grooves) text = text + this.$gettext('Grooves') + '; ';
			if(this.tongue.marks.spots) text = text + this.$gettext('Spots') + '; ';
			if(this.tongue.marks.teeth) text = text + this.$gettext('Teeth');
			return text;
		},
		movementType() {
			if(this.tongue.movement.type == 'inexistent') return this.$gettext('Inexistent');
			if(this.tongue.movement.type == 'left') return this.$gettext('Left');
			return this.$gettext('Right');
		},
		veinsType() {
			if(this.tongue.veins.type == 'normal') return this.$gettext('Normal');
			return this.$gettext('Changed');
		},
		veinsThickness() {
			if(this.tongue.veins.thickness == 0) return this.$gettext('Slim');
			if(this.tongue.veins.thickness == 1) return this.$gettext('Medium');
			return this.$gettext('Thick');
		},
		veinsTortuosity() {
			if(this.tongue.veins.tortuosity == 0) return this.$gettext('Light');
			if(this.tongue.veins.tortuosity == 1) return this.$gettext('Moderate');
			return this.$gettext('Sharp');
		}
  },
  methods: {
    getColorName(color) {
			if(color.r == 245 && color.g == 154 || color.b == 154) return 'Rosado';
			if(color.r == 255 && color.g == 180 || color.b == 179) return 'Rosado';
			if(color.r == 245 && color.g == 130 || color.b == 130) return 'Rosado';
			if(color.r == 252 && color.g == 230 || color.b == 230) return 'Rosa Pálido';
			if(color.r == 250 && color.g == 207 || color.b == 207) return 'Vermelho Pálido';
			if(color.r == 245 && color.g == 114 || color.b == 111) return 'Vermelho Rosado';
			if(color.r == 240 && color.g == 48 || color.b == 44) return 'Vermelho';
			if(color.r == 200 && color.g == 16 || color.b == 13) return 'Vermelho Escuro';
			if(color.r == 235 && color.g == 218 || color.b == 245) return 'Roxo';
			if(color.r == 195 && color.g == 145 || color.b == 170) return 'Roxo';
			if(color.r == 182 && color.g == 106 || color.b == 136) return 'Roxo';
			if(color.r == 146 && color.g == 59 || color.b == 93) return 'Bordô';
			if(color.r == 198 && color.g == 165 || color.b == 226) return 'Violeta';
			if(color.r == 172 && color.g == 131 || color.b == 225) return 'Violeta';
			if(color.r == 145 && color.g == 100 || color.b == 204) return 'Violeta';
			if(color.r == 0 && color.g == 0 || color.b == 0) return 'Preto';
			return 'Outra';
		},
		stringToRGBObject(colorString) {
			let rgbaList = colorString.replace(/^(rgb|rgba)\(/,'').replace(/\)$/,'').replace(/\s/g,'').split(',');
			let rbgObject = {
				r: Number(rgbaList[0]),
				g: Number(rgbaList[1]),
				b: Number(rgbaList[2])
			}
			return rbgObject;
		}
  }
};
</script>